import { gql } from '@apollo/client'

/**
 * Fetches all a contacts other threads.
 */
export const fetchContactThreadLinksQuery = gql`
  query FetchContactThreadLinks($contactId: Int!) {
    contact(contactId: $contactId) {
      threads(limit: 5) {
        id
        conversationType
        messageType
        leasingTask {
          id
          displayName
          taskType
          leasingInfo {
            propertyType
          }
          firm {
            id
            firmName
          }
        }
        lastMessageTime
        lastMessageSnippet
      }
    }
  }
`
